<template>
  <div>
    <v-footer color="accent" class="v-footer__content" absolute>
      <slot>
        <v-btn v-if="user.role === 'ORG_USER'" text @click="addLogBookField">
          <v-img
            max-width="31"
            max-height="31"
            :src="require('@/assets/img/book-white.svg')"
          ></v-img>
        </v-btn>
        <v-btn text>
          <v-icon color="white" @click="agronomicManagement">
            mdi-flower-tulip
          </v-icon>
        </v-btn>
      </slot>
    </v-footer>
    <v-dialog v-model="dialog" max-width="270">
      <v-card>
        <v-card-title>Manejo Agronómico</v-card-title>
        <v-card-text>
          ¿Está seguro que desea editar el manejo agronómico del área?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-2" text @click="dialog = false">
            CANCELAR
          </v-btn>
          <v-btn
            color="green darken-2"
            text
            @click="$router.push(`/agronomic-management`)"
          >
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...mapState("areasList", ["areaSelected"]),
  },
  methods: {
    agronomicManagement() {
      if (typeof this.areaSelected.landUse != "undefined" && this.areaSelected.landUse != "" || this.areaSelected.cropCycles.length > 0) {
        this.dialog = true;
      } else {
        this.$router.push(`/agronomic-management`);
      }
    },
    addLogBookField() {
      this.$router.push(`/territory/addLogbook`);
    },
  },
};
</script>

<style scoped>
.v-footer__content {
  justify-content: space-around;
}
</style>
